import { Loader } from '@mantine/core';

import useFetchCartographyTree from 'src/Hooks/Queries/useFetchCartographyTree';

import styles from './Cartography.module.scss';
import { CartographyOverview } from './components/CartographyOverview';

const Cartography = () => {
  const { data: tree, isLoading } = useFetchCartographyTree();

  if (isLoading || !tree) {
    return (
      <div className={styles.loading}>
        <Loader />
      </div>
    );
  }

  return <CartographyOverview tree={tree} />;
};

export default Cartography;
